import { PermissionOption } from '@shared/types/permissions'
import { Flex, Switch, Typography } from 'antd'

import { useStyles } from './styles'

type Props = {
  option: PermissionOption
  checked: boolean
  onToggle: (key: string, checked: boolean) => void
}

export const PermissionRow = ({ option, checked, onToggle }: Props) => {
  const { styles } = useStyles()

  return (
    <Flex
      gap={16}
      align="flex-start"
      justify="space-between"
      className={styles.row}
    >
      <Flex vertical gap={4} className={styles.rowContent}>
        <Flex gap={8} align="center" wrap>
          <Typography.Text strong>{option.label}</Typography.Text>

          <Typography.Text code className={styles.code}>
            {option.value}
          </Typography.Text>
        </Flex>

        {option.description && (
          <Typography.Text type="secondary">
            {option.description}
          </Typography.Text>
        )}
      </Flex>

      <Switch
        checked={checked}
        onChange={(next) => onToggle(option.key, next)}
      />
    </Flex>
  )
}
